import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NurseNote } from 'src/app/Models/nursenote.model';
import { Patient } from 'src/app/Models/patient.model';
import { NurseNoteService } from 'src/app/services/nurse-note.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-view-nurse-note',
  templateUrl: './view-nurse-note.component.html',
  styleUrls: ['./view-nurse-note.component.css'],
})
export class ViewNurseNoteComponent implements OnInit {
  displayedColumns: string[] = [
    'Date',
    'DoctorName',
    'ReportName',
    'Signature',
    'View',
    'Delete',
  ];

  id = 0;
  nurseNote: NurseNote[] = [];
  dataSource: MatTableDataSource<any>;
  labDocument: string = '';
  patient: Patient;

  constructor(
    private patientService: PatientService,
    private nurseNoteService: NurseNoteService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.GetReports(this.id);
    this.getPatient(this.id);
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  // ngAfterViewInit() {
  //   this.dataSource.paginator = this.paginator;
  //   this.dataSource.sort = this.sort;
  // }

  getPatient(id) {
    this.patientService.getPatientById(id).subscribe((res) => {
      this.patient = res;
    });
  }
  GetReports(id) {
    this.patientService.getNurseNote(id).subscribe((res) => {
      this.dataSource = new MatTableDataSource(
        res.NurseNotes.sort(function (x, y) {
          return y.NurseNoteId - x.NurseNoteId;
        })
      );
      this.dataSource.paginator = this.paginator;
    });
  }
  delete(id) {
    this.nurseNoteService.deleteNurseNote(id).subscribe((res) => {
      this.GetReports(this.id);
    });
  }
  print() {
    window.print();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  public viewReport(report: NurseNote): void {
    // console.log('report: ', report);
    this.labDocument = report.ReportDescription;
  }
}
